import React from 'react';
import ThreeScene from './components/ThreeScene';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';
import SmokeyCursor from './components/lightswind/smokey-cursor.tsx';

function App() {
  return (
    <div className="app">
      {/* Pure Three.js 3D Background */}
      <ThreeScene />
<SmokeyCursor />
      {/* Content */}
      <div className="content">
        <Navigation />
        <Hero />
        <About />
        <Skills />
        <Projects />
        <Contact />
        <Footer />
      </div>
    </div>
  );
}

export default App;
